import { Injectable, inject } from '@angular/core';
import { KeyValueRoleModel } from '@models/common';
import { HttpService } from '@shared/services';

type AssignUserQueryParams = {
  contractId: number;
  moduleId: number;
  entityInstanceId: number;
  role: KeyValueRoleModel<string, string>;
};

@Injectable({
  providedIn: 'root',
})
export class StateAssignmentService {
  private http = inject(HttpService);

  assignUser({ role, moduleId, ...rest }: AssignUserQueryParams) {
    const params = this.http.buildHttpParams(rest);
    const headers = moduleId ? { moduleId: moduleId.toString() } : undefined;

    return this.http.put<void>('_api/StateAssignment/AssignUser', role, {
      httpOptions: { params, headers },
      useLoader: false,
    });
  }
}
